import { Socket } from "phoenix";
import { config } from "@/config";

export interface SocketHandle {
  socket: Socket;
  connect: () => void;
  disconnect: () => Promise<void>;
}

export function createSocket(token: string): SocketHandle {
  const socket = new Socket(config.realtimeUrl, {
    params: () => ({ token }),
    logger: (kind, msg, data) => {
      if (import.meta.env.DEV) {
        console.debug(`[phx ${kind}]`, msg, data);
      }
    },
  });

  return {
    socket,
    connect: () => {
      socket.connect();
    },
    disconnect: () =>
      new Promise<void>((resolve) => {
        socket.disconnect(() => resolve());
      }),
  };
}
